<template lang="html">
  <div class="container-fluid __windowHeight_">
    <div class="row h-100">
       <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
          <div class="paymenthistory_page">
            <div class="container-fluid p-0 __100vh_">
              <div class="row justify-content-between __pathlist2_ __wrapper_">
                <p class="__path">Payment &gt; Payment History &gt; <span>{{ $route.params.orderNumber }}</span></p>
              </div>
              <div class="__mastercontent">
                <keep-alive>
                    <HistoryStatus></HistoryStatus>
                </keep-alive>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import HistoryStatus from '@/components/payment/paymentStatus/HistoryStatus.vue'
export default {
  name: 'paymentHistory',
  components: {
    Sidebar,
    HistoryStatus
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/view/paymentHistory/index.vue